import {useEffect, useState} from "react";
import Input from "./Input";
import InputLabel from "./InputLabel";
import Validator from "../Validator";

function TextInput({type = "text", initialError, value, id, title, required, setValue, updateObject}) {
    const [error, setError] = useState(initialError);
    useEffect(() => {setError(initialError);}, [initialError]);

    function validate(text) {
        setError(Validator.validateField(text, id, required, type));
    }

    return (
        <div className="group relative z-0 w-full">
            <Input type={type} value={value} id={id} required={required} setValue={setValue} error={error}
                   validate={validate} updateObject={updateObject}/>
            <InputLabel id={id} title={title} required={required} error={error}/>
        </div>
    );
}

export default TextInput;